import { EnvironmentUrls } from 'Roblox';
import { httpService } from 'core-utilities';

export default {
  getIXPEnrollments: surface => {
    const urlConfig = {
      url: `${EnvironmentUrls.apiGatewayUrl}/product-experimentation-platform/v1/projects/1/layers/${surface.Layer}/values`,
      withCredentials: true
    };
    const data = {
      parameters: surface.Parameters.join(',')
    };
    return httpService.get(urlConfig, data).then(response => {
      if (response?.data) {
        return response.data;
      }
      return Promise.reject();
    });
  },

  // Experiments that require text changes are run on english only so that we
  // can iterate faster without waiting for translations
  isBrowserLanguageEnglish: () => {
    return /^en\b/.test(navigator.language);
  }
};
